<template>
  <div style="display:flex;align-items:center;gap:4px;margin-bottom:0;">
    <el-select ref="whId" v-model="whId" :placeholder="$t('SearchWhseClient.whName')" size="small" style="width:180px;">
      <el-option v-for="(whse,index) in this.whseData" :key="index" :value="whse.whId"
                 :label="whse.name" @click.native="getClient"/>
    </el-select>
    <el-select @change="putWhseClient" ref="clientCode" v-model="clientCode" :placeholder="$t('SearchWhseClient.clientName')" size="small" style="width:180px;">
      <el-option v-for="(client,index) in this.clientData" :key="index" :value="client.clientCode"
                 :label="client.name"/>
    </el-select>
  </div>
</template>

<script>
import { hasPermission } from '@/permission/index.js'
export default {
  name: 'SearchWhseClient',
  props: {
    whId: {
      type: String,
      default: ''
    },
    clientCode: {
      type: String,
      default: ''
    },
    icon: {  // 显示图标
      type: String,
      default: ''
    },
    size: {  // 尺寸
      type: String,
      default: 'mini'
    },
    type: {  // 类型
      type: String,
      default: null
    },
    loading: {  // 加载标识
      type: Boolean,
      default: false
    },
    disabled: {  // 是否禁用
      type: Boolean,
      default: false
    },
    perms: {  // 权限标识，外部使用者传入
      type: String,
      default: null
    }
  },
  data() {
    return {
      whId:'',
      clientCode:'',
      whseData:Object,
      clientData:Object,
      whseClientData: {
        whId:null,
        clientCode:null}
    }
  },
  watch: {
    // 外部传入的 whId 变化时，重新获取货主数据
    whId(newVal) {
      if (newVal) {
        this.getClient()
      }
    }
  },
  methods: {
    //获取仓库下拉列表
    getWhse: function (){
      let user = sessionStorage.getItem('user')
      let objUserName = {userName:user}
      this.$wmsApi.globalOption.getWhse(objUserName)
      .then(res =>
        {
          //请求返回的数据
          this.whseData = res.data
          // 外部传了 whId prop，直接用它；否则默认选第一个
          if (this.whId && this.whseData.some(w => w.whId === this.whId)) {
            // whId prop 合法，保持不动，让 watch -> getClient 去拉货主
          } else {
            // 没有合法 prop，默认选第一个仓库
            this.whId = this.whseData[0].whId
            this.getClient()
          }
        })
    },
    //获取货主下拉列表
    getClient: function (){
      let objWhId = {whId:this.whId}
      this.$wmsApi.globalOption.getClient(objWhId)
        .then(res =>
        {
          //请求返回的数据
          this.clientData = res.data
          // 外部传了 clientCode prop，直接用它；否则默认选第一个货主
          if (this.clientCode && this.clientData.some(c => c.clientCode === this.clientCode)) {
            // clientCode prop 合法，保持不动
          } else {
            this.clientCode = this.clientData.length > 0 ? this.clientData[0].clientCode : ''
          }
          this.putWhseClient()
        })
    },
    putWhseClient: function (){
      return this.$emit('search-whse-event',this.whId,this.clientCode);
    },
    hasPerms: function (perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms) & !this.disabled
    }
  },
  created() {
    // 外部传入了 whId/clientCode，先设置到本地 data，再拉列表
    this.whId = this.whId
    this.clientCode = this.clientCode
    this.getWhse()
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Core/SearchWhseClient.vue